import type React from 'react';
import Modal from 'react-modal';
import Close from '@mui/icons-material/Close';
import ZoomIn from '@mui/icons-material/ZoomIn';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import { useDiploma } from './model';
import * as st from './styles.module.scss';

Modal.setAppElement('#root');

type DiplomaModalProps = {
  url: string;
  close: () => void;
};

const DiplomaModal: React.FC<DiplomaModalProps> = ({ url, close }) => {
  return (
    <Modal isOpen className={st.viewer} overlayClassName={st.overlay} ariaHideApp={false}>
      <div className={st.wrapper}>
        <button className={st.wrapper__close} onClick={close}>
          <Close />
        </button>
        <img className={st.wrapper__image} src={url} alt="diploma" />
      </div>
    </Modal>
  );
};

type Diplom = {
  coach: number;
  id: number;
  image: string;
};

type DiplomaListProps = {
  id: number;
};

export const Diploma: React.FC<DiplomaListProps> = ({ id }) => {
  const { data: coach } = useCoachQuery({ id: String(id) });
  const { selected, setDiplomaUrl } = useDiploma();

  return (
    <>
      {!!coach?.diplom.length && (
        <section className={st.diplomas}>
          <h2 className={st.diplomas__title}>Дипломы и сертификаты</h2>
          <div className={st.diplomas__wrapper}>
            {coach?.diplom &&
              coach?.diplom.map((diploma: Diplom) => (
                <div
                  key={diploma.id}
                  className={st.diplomas__diplom}
                  onClick={() => setDiplomaUrl(diploma.image)}
                >
                  <div className={st.diplomas__icon}>
                    <ZoomIn />
                  </div>
                  <img key={diploma.id} src={diploma.image} alt="" className={st.diplomas__image} />
                </div>
              ))}
          </div>

          {!!selected && <DiplomaModal url={selected} close={() => setDiplomaUrl('')} />}
        </section>
      )}
    </>
  );
};
